import { Link } from 'react-router-dom'
import { SeverityDonut } from '@/shared/components/SeverityDonut'
import { HelpIcon } from '@/shared/components/HelpIcon'
import type { TenantAnalytics } from '@/lib/apiTypes'
import { rowStyle } from '@/features/dashboard/cards/styles'

export function TopRiskWorkspacesCard({ workspaces }: { workspaces: TenantAnalytics['top_risk_workspaces'] }) {
  return (
    <div className="card fu">
      <div className="card-header">
        <div>
          <div className="kicker">Risk</div>
          <h3 style={{ fontSize: '0.95rem' }}>Highest risk state workspaces</h3>
        </div>
        <HelpIcon track="help_highest_risk_workspaces" title="Highest risk state workspaces" kicker="// what this implies">
          <p>State workspaces ranked by their count of unresolved
          <strong> critical</strong> and <strong>high</strong> findings from scanning
          the resources tracked in their state.</p>
          <p>Unlike module findings (risk waiting to be consumed), these reflect risk
          that is already <strong>live in your infrastructure</strong>. Workspaces at
          the top of this list are where misconfiguration or policy violations are
          actually running - prioritise remediating these first.</p>
        </HelpIcon>
      </div>
      {workspaces.map((w, i) => (
        <Link
          key={i}
          to={`/org/${w.org_slug}/state/${encodeURIComponent(w.workspace_name)}`}
          style={rowStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg3)')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '')}
        >
          <div style={{ fontFamily: 'var(--mono)', fontSize: '0.8rem', color: 'var(--text)' }}>
            {w.workspace_name}
          </div>
          <SeverityDonut
            critical={w.critical_count}
            high={w.high_count}
            total={w.critical_count + w.high_count}
            focusable={false}
          />
        </Link>
      ))}
    </div>
  )
}
